// extracted by mini-css-extract-plugin
export default {"compliance":"compliance_compliance__paqmL","compliance__container":"compliance_compliance__container__NJA4q"};